import { useContext } from 'react';
import { useSelectOnlyFilterFamilyAndField } from '../../hooks/useSelectOnlyFilterFamilyAndField';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import EditorFilterFamilySelect from './EditorFilterFamilySelect';
import EditorConditionFieldSelect from './EditorConditionFieldSelect';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorConditionSelect = () => {
  const {
    selectedFilterFamily,
    isLoadingFields,
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  useSelectOnlyFilterFamilyAndField();
  return /*#__PURE__*/_jsxs(Flex, {
    "data-test-id": "fr-condition-select",
    blockSize: "100%",
    flexDirection: "column",
    children: [!selectedFilterFamily && /*#__PURE__*/_jsx(EditorFilterFamilySelect, {}), !useOnePanel && isLoadingFields && /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.fieldSelectFlow.loadingFields"
      }),
      showLabel: true,
      size: "small"
    }), selectedFilterFamily && (useOnePanel || !isLoadingFields) && /*#__PURE__*/_jsx(EditorConditionFieldSelect, {
      filterFamily: selectedFilterFamily.filterFamily
    })]
  });
};
export default EditorConditionSelect;